import styled from "styled-components";
import { memo } from "react";
import { PopoverBaseArrowStyled, PopoverBaseContentStyled } from "../PopoverBase/PopoverBase.styles"; // Стилизуем базовый поповерный контейнер для контента

export var PopoverWrapperStyled = styled(PopoverBaseContentStyled).withConfig({
  displayName: "Popoverstyles__PopoverWrapperStyled",
  componentId: "sc-1e0vns6-0"
})(function (_ref) {
  var theme = _ref.theme;
  var _theme$componentsToke = theme.componentsTokens.popover,
      backgroundColor = _theme$componentsToke.backgroundColor,
      padding = _theme$componentsToke.padding,
      borderRadius = _theme$componentsToke.borderRadius,
      boxShadow = _theme$componentsToke.boxShadow,
      color = _theme$componentsToke.color;
  return {
    backgroundColor: backgroundColor,
    padding: padding,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    color: color
  };
}); // Стилизуем стрелку для поповера

export var PopoverArrowStyled = /*#__PURE__*/memo(styled(PopoverBaseArrowStyled).withConfig({
  displayName: "Popoverstyles__PopoverArrowStyled",
  componentId: "sc-1e0vns6-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    "::before": {
      backgroundColor: theme.componentsTokens.popover.backgroundColor,
      boxShadow: theme.componentsTokens.popover.arrowBoxShadow
    }
  };
}));